
import React, { PropTypes } from 'react';

import './style.scss';

const AccordionCheckbox = props => {
  function handleCheckboxChange() {

    if(props.onClick) {
      props.onClick({
        id: props.id,
        isChecked: props.isChecked
      });
    }
  }

  return (
    <div className="AccordionCheckbox">
      <div className="checkbox-wrap">
        <input
          id={`accordion-checkbox-${props.id}`}
          name={`accordion-checkbox-${props.id}`}
          type="checkbox"
          checked={props.isChecked}
          onChange={handleCheckboxChange}
        />
        <label htmlFor={`accordion-checkbox-${props.id}`}>{props.title}</label>
      </div>
    </div>
  );
};

AccordionCheckbox.propTypes = {
  id: PropTypes.number,
  title: PropTypes.string,
  isChecked: PropTypes.bool,
  onClick: PropTypes.func
};

export default AccordionCheckbox;



/** WEBPACK FOOTER **
 ** ./src/members/Main/__shared__/components/Accordion/AccordionCheckbox/index.js
 **/